import { useQuery } from "@tanstack/react-query";
import { projectActivityApi } from "@/lib/api/crm";

export const PROJECT_ACTIVITY_KEY = "project-activity";

export function useProjectActivity(projectId: string) {
  return useQuery({
    queryKey: [PROJECT_ACTIVITY_KEY, projectId],
    queryFn: () => projectActivityApi.getActivity(projectId),
    enabled: !!projectId,
  });
}
